export default __webpack_public_path__ + "static/media/regulatory--stop--g10.505ed820.png";